import { all, fork } from 'redux-saga/effects';

import { transactions } from './transactions/actions';
import { hotWallets } from './hotWallets/actions';
import { profit } from './profit/actions';
import { bnixFee } from './bnixFee/actions';
import { gasFeeSettings } from './gasFeeSettings/actions';
import { historyReplenishment } from './historyReplenishment/actions';

export function* wallets() {
  yield all([
    fork(transactions),
    fork(hotWallets),
    fork(profit),
    fork(bnixFee),
    fork(gasFeeSettings),
    fork(historyReplenishment),
  ]);
}
